<agpr-take-over-panel
    [id]="'manageTagsDialog'"
    header="Tags.manageDialog.header"
    class="agpr-manageTags-dialog"
    (visibleChange)="cancel()"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="700"
    [maxPanelWidth]="1500"
>
    <!-- Dialog Content -->
    <div class="agpr-manageTags-content">
        <agpr-tabs
            (selectedTabIndexChange)="tabChange($event)"
        >
            <agpr-tab
                noScrollPanelContent
                class="agpr-manageTags-tabs"
                [heading]="'Tags.manageDialog.tagsTabHeader' | localize"
                [id]="'manageTagsDialog.tagsTab'"
                [style.display]="selectedTab === 0 ? 'block' : 'none'"
            >
                <agpr-table
                    [id]="'existingTagTable'"
                    class="agpr-manage-tags-table"
                    [columns]="tagColumnDefs"
                    [showDelete]="true"
                    deleteLabel="Tags.manageDialog.deleteIconTooltip"
                    [showView]="true"
                    [actionMenu]="true"
                    [actionMenuIcons]="false"
                    actionMenuTextAlignment="right"
                    [extraActions]="tagRowActions"
                    [sortColumn]="tagNameColumn"
                    [sortAscending]="true"
                    [(ngModel)]="rowData"
                    (ngModelChange)="checkForSelected()"
                    (itemChanged)="saveTag($event)"
                    (itemDelete)="deleteTag($event)"
                    (itemView)="view($event)"
                ></agpr-table>
            </agpr-tab>
            <agpr-tab
                noScrollPanelContent
                [heading]="'Tags.manageDialog.tagGroupsTabHeader' | localize"
                [id]="'manageTagsDialog.tagGroupsTab'"
                [style.display]="selectedTab === 1 ? 'block' : 'none'"
            >
                <agpr-table
                    [id]="'existingTagGroupTable'"
                    class="agpr-manage-tags-table"
                    [columns]="tagGroupColumnDefs"
                    [showDelete]="true"
                    deleteLabel="Tags.manageDialog.deleteTagGroupTooltip"
                    [showView]="true"
                    [actionMenu]="true"
                    [actionMenuIcons]="false"
                    actionMenuTextAlignment="right"
                    [extraActions]="tagGroupRowActions"
                    [sortColumn]="tagGroupNameColumn"
                    [sortAscending]="true"
                    [(ngModel)]="tagGroupRowData"
                    (ngModelChange)="checkForSelected()"
                    (itemChanged)="saveTagGroup($event)"
                    (itemDelete)="deleteTagGroup($event)"
                    (itemView)="view($event)"
                ></agpr-table>
            </agpr-tab>
        </agpr-tabs>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="hasSelectedTags"
            label="Tags.manageDialog.delete"
            [style]="buttonTypes.primaryB"
            (click)="deleteSelected()"
        ></agpr-button>
        <agpr-button
            *ngIf="hasSelectedTagGroups"
            label="Tags.manageDialog.delete"
            [style]="buttonTypes.primaryB"
            (click)="deleteSelectedTagGroups()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedTab === 1"
            label="Tags.manageDialog.newGroupButton"
            [style]="buttonTypes.primaryB"
            (click)="createTagGroup()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedTab === 0"
            label="Tags.manageDialog.newButton"
            [style]="buttonTypes.primaryB"
            (click)="createTag()"
        ></agpr-button>
        <agpr-button
            label="done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template let-row="row" let-column="column" #tagCell>
    <div class="agpr-manageTags-customCellWrapper agpr-table-row">
        <agpr-tags-picker
            *ngIf="selectedTab === 1"
            class="agpr-manageTags-customCellTagPicker"
            [isInTable]="true"
            [ngModel]="row[column.field]"
            (ngModelChange)="tagGroupTagsUpdated($event, row)"
            [showHeader]="false"
            [showManageTags]="false"
            [id]="row.createdDateRaw + '_manageTags_customCellTagPicker'"
        ></agpr-tags-picker>
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-table-cell agpr-manageTags-customCellIcon"
            [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                createdDate: row.createdDate,
                createdBy: row.createdByUser,
                modifiedDate: row.lastModifiedDate,
                modifiedBy: row.lastModifiedByUser
            }"
            [initiallyFocusable]="false"
        ></span>
    </div>
</ng-template>
